import type React from 'react';
import { createContext, useContext, useRef } from 'react';

type PreSubmitCallback = () => Promise<boolean> | boolean | void;

type PreSubmitCallbackContextType = {
  setPreSubmitCallback: (callback: PreSubmitCallback | null) => void;
  getPreSubmitCallback: () => PreSubmitCallback | null;
};

const PreSubmitCallbackContext = createContext<PreSubmitCallbackContextType | undefined>(undefined);

export function PreSubmitCallbackProvider({ children }: { children: React.ReactNode }) {
  const callbackRef = useRef<PreSubmitCallback | null>(null);

  const setPreSubmitCallback = (callback: PreSubmitCallback | null) => {
    callbackRef.current = callback;
  };

  const getPreSubmitCallback = () => {
    return callbackRef.current;
  };

  return (
    <PreSubmitCallbackContext.Provider value={{ setPreSubmitCallback, getPreSubmitCallback }}>
      {children}
    </PreSubmitCallbackContext.Provider>
  );
}

export function usePreSubmitCallback() {
  const context = useContext(PreSubmitCallbackContext);
  if (context === undefined) {
    return {
      setPreSubmitCallback: () => {},
      getPreSubmitCallback: () => null,
    };
  }
  return context;
}
